// outboxTypes.js
// Action Types
export const OUTBOX_FETCH_REQUEST = "OUTBOX_FETCH_REQUEST";
export const OUTBOX_FETCH_SUCCESS = "OUTBOX_FETCH_SUCCESS";
export const OUTBOX_FETCH_FAILURE = "OUTBOX_FETCH_FAILURE";
export const OUTBOX_RETRY_REQUEST = "OUTBOX_RETRY_REQUEST";
export const OUTBOX_RETRY_SUCCESS = "OUTBOX_RETRY_SUCCESS";
export const OUTBOX_RETRY_FAILURE = "OUTBOX_RETRY_FAILURE";
export const OUTBOX_SET_FILTERS = "OUTBOX_SET_FILTERS";
export const OUTBOX_SET_AUTO_REFRESH = "OUTBOX_SET_AUTO_REFRESH";
export const OUTBOX_CLEAR_ERROR = "OUTBOX_CLEAR_ERROR";

// Preview Action Types
export const OUTBOX_PREVIEW_REQUEST = "OUTBOX_PREVIEW_REQUEST";
export const OUTBOX_PREVIEW_SUCCESS = "OUTBOX_PREVIEW_SUCCESS";
export const OUTBOX_PREVIEW_FAILURE = "OUTBOX_PREVIEW_FAILURE";
export const OUTBOX_CLEAR_PREVIEW = "OUTBOX_CLEAR_PREVIEW";
